import React from 'react';
import { animated, useSpring } from 'react-spring';

/**
 *
 * @param {boolean} rotate - condition that will rotate the div by num degrees
 * @param {number} from - degree the div will rotate from
 * @param {number} to - degree the div will rotate to
 * @param {object} config - additional spring configs - https://react-spring.io/common/configs
 */
export const AnimateRotate = ({ children, rotate, from, to, config = {} }) => {
  const animateRotate = useSpring({
    config,
    from: { display: 'flex', transform: `rotate(${from}deg)` },
    to: {
      transform: rotate ? `rotate(${from}deg)` : `rotate(${to}deg)`,
    },
  });
  return <animated.div style={{ ...animateRotate }}>{children}</animated.div>;
};
